import { render } from "./Contact.vue?vue&type=template&id=1e315102&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=1e315102&scoped=true&lang=scss"

import exportComponent from "/builds/blat/bcard-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e315102"]])

export default __exports__